<script setup>
const props = defineProps({
    automationId: {
        type: Number,
        required: true,
    },
    readOnly: {
        type: Boolean,
        default: false,
    },
})
</script>
<template>
    <div>
        <div v-if="readOnly" class="mb-4 p-4 bg-blue-50 border border-blue-200 rounded-lg text-blue-800 text-sm">
            These are legacy automations. New automations should be created in <a :href="route('bo.crm.workflows.index')" class="mf-link font-medium">Workflows</a>.
        </div>
        <communications-automation-composer
            :automation-id="automationId"
            :read-only="readOnly"
        />
    </div>
</template>
